// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__tnzbR","list":"BalanceDue_list__WDh4T","listRow":"BalanceDue_listRow__aKQOd","total":"BalanceDue_total__2k7ET"};